// Prefer a cut-out (transparent) per-color image over the raw Odoo catalog photo (white bg).
export const cutoutImage = (p) =>
  (p?.colors || []).map((c) => (c.images || [])[0]).find(Boolean) || p?.images?.[0];
